export const T = {
  en_GB: {
    riskAssessmentNotConfigured: "Risk assessment not configured for this flow.",
  },
  nb_NO: {
    riskAssessmentNotConfigured: "Risikovurdering er ikke konfigurert for denne flyten.",
  },
} as const;
